var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"message__date"},[_vm._v(_vm._s(_vm.messageTime())+"\n    "),_c('svg',{staticClass:"chat__check-icon",class:{'is-read':_vm.isReadOpponent},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"14"}},[_c('use',{attrs:{"xlink:href":`${_vm.myUrl}/source/images/icons/icons.svg#check`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }